import Utils from '../../util';
import { FeedstockBmpCurveItem } from '../project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-curve.model';

interface InputSelectionTableItemInterface {
  id?: string
  nameElements?: string[]
  min?: number | null,
  minErrorHints?: string[],
  max?: number | null,
  maxErrorHints?: string[],
  value?: number,
  unit?: string,
  category?: string,
  path?: string[],
  curve?: FeedstockBmpCurveItem
}
export class InputSelectionTableItem {
  id?;
  nameElements;
  min?;
  minErrorHints;
  max?;
  maxErrorHints;
  value?;
  unit?;
  category?;
  path?;
  curve?;
  constructor(param: InputSelectionTableItemInterface = {})
  {
    if (Utils.isNumeric(param.min)) this.min = param.min;
    if (Utils.isNumeric(param.max)) this.max = param.max;
    this.id = param.id;
    this.nameElements = param.nameElements ?? [];
    this.value = param.value;
    this.unit = param.unit;
    this.category = param.category;
    this.path = param.path;
    this.curve = param.curve;

    this.minErrorHints = param.minErrorHints ?? [];
    this.maxErrorHints = param.maxErrorHints ?? [];
  }
}
